module.exports = __webpack_public_path__ + "img/2162460.4bca9e29.jpg";